import Medusa, { Client, Config, RequestOptions } from "@medusajs/medusa-js"
import { AxiosRequestHeaders } from "axios"

class MedusaApiClient extends Medusa {
  private static token?: string

  constructor(config: Config) {
    super(config)
  }

  /**
   * Sets the authentication token for client-side use.
   *
   * **NOTE**: This method only allows to set auth tokens in the browser environment.
   * When we run Next.js in server envs like Vercel the execution context could be shared between requests.
   * Storing tokens in a static variable on the server can lead to unintended token leakage and unexpected behavior
   * across requests.
   *
   * @param {string} token - The authentication token to be set.
   * @throws {Error} If called in a server-side environment.
   */
  static setToken(token?: string) {
    if (typeof window == "undefined") {
      throw new Error("Can't set a static token server side")
    }

    this.token = token
  }

  static getToken() {
    return this.token
  }
}

export type RequestMethod = "DELETE" | "POST" | "GET"
const originalSetHeaders = Client.prototype.setHeaders

Client.prototype.setHeaders = function (
  userHeaders: RequestOptions,
  method: RequestMethod,
  path: string,
  customHeaders: Record<string, any> = {}
): AxiosRequestHeaders {
  const token = MedusaApiClient.getToken()

  if (token) {
    customHeaders = {
      Authorization: `Bearer ${token}`,
      ...customHeaders,
    }
  }

  return originalSetHeaders.call(this, userHeaders, method, path, customHeaders)
}

export default MedusaApiClient
